module.exports = __webpack_public_path__ + "04_short_grey.82510969.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/male/layer5/04_short_grey.png
// module id = AiVO
// module chunks = 0